import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const HeaderMenuContextDefaultProps = {
  ...ChildrenDefaultProps,
};

export const HeaderMenuContextPropTypes = {
  ...ChildrenPropTypes,
};
